import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signOut, logoutFunc } from "../../../Features/AuthSlice";

import "./LWKBLanding.css";
import "../../../Assets/styles/styles.css"
import AgencyLogin from "./AgencyLogin";


/* ==========================================
   SMALL COMPONENTS
========================================== */

function Pill({ children }) {
  return (
    <span className="custom-pill mb-3">
      {children}
    </span>
  );
}


function SignInCard() {

  const [showPw, setShowPw] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state) => state.auth.currentUser?.token);
  const deviceToken = useSelector((state) => state.auth.deviceToken);
  const isLoggedIn = !!token;

  const handleLogout = () => {
    localStorage.removeItem("agencyLogo");
    window.dispatchEvent(new Event("logoChanged"));

    dispatch(signOut({ token, deviceToken }));
    dispatch(logoutFunc());
  };

  if (isLoggedIn) {
    return (
      <div className="signin-card d-grid gap-3">
        <Button
          className="signin-btn"
          onClick={() => navigate("/dashboard")}
        >
          Return to Dashboard
        </Button>
        <Button
          variant="outline-secondary"
          onClick={handleLogout}
        >
          Logout
        </Button>
      </div>
    );
  }

  return (
    <div className="signin-card">
      <AgencyLogin />
    </div>
  );
}



function TaegeukMark({ size = 120 }) {

  return (

    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
    >

      <circle
        cx="50"
        cy="50"
        r="49"
        fill="none"
        stroke="#E4EAF1"
      />


      <path
        d="M50 1
        A49 49 0 0 1 50 99
        A24.5 24.5 0 0 1 50 50
        A24.5 24.5 0 0 0 50 1Z"
        fill="#D42C3C"
      />


      <path
        d="M50 1
        A49 49 0 0 0 50 99
        A24.5 24.5 0 0 0 50 50
        A24.5 24.5 0 0 1 50 1Z"
        fill="#1F4E8C"
      />


      <circle
        cx="50"
        cy="25.5"
        r="8"
        fill="#1F4E8C"
      />


      <circle
        cx="50"
        cy="74.5"
        r="8"
        fill="#D42C3C"
      />


    </svg>

  );
}




function FlightPath() {

  return (

    <div className="flight-path">

      <svg
        viewBox="0 0 320 140"
        className="flight-svg"
      >

        <path
          d="
          M10 90
          C90 10,
          170 10,
          230 55
          S300 100,
          310 60"
          fill="none"
          stroke="#1F4E8C"
          strokeWidth="1.5"
          strokeDasharray="2 7"
          opacity=".55"
        />


        <circle
          cx="300"
          cy="65"
          r="26"
          fill="none"
          stroke="#1F4E8C"
          strokeDasharray="2 5"
          opacity=".4"
        />

      </svg>


      <i className="bi bi-airplane airplane-icon" />

    </div>

  );
}

function SocialLink({ icon, label, href }) {

  return (

    <a
      href={href}
      className="social-link"
    >

      <span className="social-icon">

        <i className={icon} />

      </span>

      {label}

    </a>

  );

}





/* ==========================================
   MAIN PAGE
========================================== */


export default function LWKBLanding() {


  return (

    <div>


      {/* HERO */}

      <section className="hero-section">


        <div className="hero-grid" />


        <Container className="position-relative py-5">


          <Row className="align-items-center mt-5 gy-5">


            <Col lg={7}>


        


              <h1 className="section-title">
                  Empowering Agents.  Connecting  Korea.
              </h1>




              <p className="hero-description description">

                A dedicated portal for our partner agents —
                manage applications, track students, and grow
                your business with Korea’s trusted Korean
                language institute.

              </p>
            </Col>
            <Col
              lg={5}
              className="d-flex justify-content-center justify-content-lg-end"
            >
              <SignInCard />
            </Col>
          </Row>
        </Container>


      </section>
      <section className="about-section">
        <Container>
          <Row className="align-items-center gy-5">
            <Col lg={6}>
              <div className="about-image">
                <img
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1200&auto=format&fit=crop"
                  alt="Korean language class"
                />
              </div>
            </Col>
            <Col lg={6}>
            
              <h2 className="about-title mb-3">
                Specializes in teaching the Korean language
              </h2>
              <p className="description">

                We are dedicated to teaching the Korean language
                with a high degree of accuracy and fluency.
                We offer a variety of classes, including beginner,
                intermediate, and advanced classes.

                Classes on EPS TOPIK, Academic TOPIK I and II,
                KIIP Level Test Preparation, and KIIP Level 0 to 5
                are a few to list.

                The institute’s goal is to make the learning
                experience fun and engaging while helping
                students reach their full potential in the language.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
   
      <footer className="footer">
       
        <Container className="position-relative py-3">
        
          <div className="footer-bottom d-flex flex-column flex-sm-row justify-content-between gap-2">
            <span>
              © 2026 UBT Exam. All Rights Reserved.
            </span>
            <span>
              Website Designed and Developed by <a href="https://www.genesiswtech.com" target="_blank" rel="noopener noreferrer">Genesis Web Technology</a> 
            </span>
          </div>
        </Container>
      </footer>
    </div>

  );

}